import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'


export default /*@__PURE__*/_defineComponent({
  __name: 'BloggerSearchCpa',
  props: {
  modelValue: {
    type: [String, Array],
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue', 'update:name', 'changeValues'],
  setup(__props, { emit: __emit }) {

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = __props

const emits = __emit

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(() => {
  search('')
})
watch(props, (newVal) => {
  console.log('watch', newVal.modelValue);
  
  if (newVal.modelValue) {
    let name = newVal.name ? newVal.name.split(']')[1] : ''
    if (!suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/bloggers/suggestion`, {
        // blogger_id: newVal.modelValue,
        blogger_name: name,
        is_strict: props.isStrict,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.suggestion) {
          let value = v.director_name?`${v.username} (${v.director_name})`:v.username
          suggestionData.value.push({
            label: value,
            value: v.id
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      try {
        request.get(`/api/bloggers/suggestion`, {
          blogger_name: name,
          is_strict: props.isStrict,
        }).then((rsp:any) => {
          suggestionData.value = []
          for (let v of rsp.data.suggestion) {
            let value = v.director_name?`${v.username} (${v.director_name})`:v.username
            suggestionData.value.push({
              label: value,
              value: v.id
            })
          }
        })
      } catch(err){
        console.log('err')
      }
    }, 600)
  
}

const onChange = (item, options) => {
  console.log('onChange',item, options);
  if (item) {
    // emits('changeValues', {blogger_name: options.label})
    emits('update:modelValue', item)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    "show-search": "",
    style: {"width":"100%"},
    allowClear: true,
    "default-active-first-option": false,
    "show-arrow": false,
    "filter-option": false,
    "not-found-content": null,
    options: suggestionData.value,
    onSearch: search,
    mode: __props.mode,
    onChange: onChange,
    disabled: __props.disabled
  }, null, 8, ["value", "options", "mode", "disabled"]))
}
}

})